import React, { useState, useEffect, useMemo } from "react";
import Topbar from "../../components/Topbar/Topbar";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Table } from "../../components/Table/Table";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { get, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { toast } from "react-toastify";

const READ_STATUS = {
  UNREAD: "UnRead",
  READ: "Read",
};

const AiNotification = () => {
  const { paginationData, setpaginationData } = useGlobalContext();
  const location = useLocation();
  const path = location.pathname?.replace("/", "");
  const [isCount, setIsCount] = useState("");

  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);

  const [pagination, setPagination] = useState(
    paginationData?.[path]?.pagination ?? {
      UnRead: {},
      Read: {},
    },
  );
  const [list, setList] = useState({ UnRead: [], Read: [] });

  const [isActiveTab, setIsActiveTab] = useState(
    paginationData?.[path]?.isActiveTab ?? READ_STATUS.UNREAD,
  );
  const [selectedFilter, setSelectedFilter] = useState(
    paginationData?.[path]?.selectedFilter ?? {
      from: "",
      to: "",
    },
  );
  const [openRemark, setOpenRemark] = useState(false);
  const [remark, setRemark] = useState("");

  const handleFilter = (key, val) => {
    setSelectedFilter((prev) => ({ ...prev, [key]: val }));
  };

  const addToGlobal = (d = {}) => {
    setpaginationData((prev) => ({
      ...prev,
      [path]: { ...prev?.[path], ...d },
    }));
  };

  const handleCloseRemark = () => {
    setOpenRemark(false);
    setRemark("");
  };

  const handleTabChange = (status) => {
    setIsActiveTab(status);
    setPage(1);
  };

  const columns = useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "s_no",
        Cell: ({ row }) => (
          <p>
            {(pagination?.[isActiveTab]?.current_page - 1) * 10 +
              (row.index + 1)}
          </p>
        ),
      },
      {
        Header: "Title",
        accessor: "title",
        Cell: ({ value }) => (
          <p className="text-nowrap">{value || "-"}&nbsp;</p>
        ),
      },
      {
        Header: "Description",
        accessor: "message",
        Cell: ({ value }) => (
          <div style={{ width: 350 }}>
            <p>{value || "-"}&nbsp;</p>
          </div>
        ),
      },
      {
        Header: "Date",
        accessor: "created_at",
        Cell: ({ value }) => (
          <p className="text-nowrap">
            {value ? moment(value).format("DD/MM/YYYY hh:mm A") : "-"}
          </p>
        ),
      },
      {
        Header: isActiveTab !== READ_STATUS.READ ? "Marked Read" : "Comments",
        accessor: "action",
        Cell: ({ row }) => {
          if (isActiveTab === READ_STATUS.READ) {
            return (
              <p
                style={{
                  maxWidth: 450,
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  display: "-webkit-box",
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                }}
              >
                {row?.original?.comments || "-"}
              </p>
            );
          }
          return (
            <div className="d-flex ac-js">
              <button
                onClick={() => setOpenRemark(row.original)}
                className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14"
                style={{ background: "#9a36e69c" }}
              >
                Remark
              </button>
            </div>
          );
        },
      },
    ],
    [pagination, isActiveTab],
  );

  //API Functions

  const getList = async (pageNo = 1) => {
    const params = new URLSearchParams({
      page: pageNo,
      status: isActiveTab === READ_STATUS.UNREAD ? 1 : 2,
    });

    if (selectedFilter.to) {
      params.append("from_date", selectedFilter.from);
      params.append("to_date", selectedFilter.to);
    }

    const url = `${URLS.AI_NOTIFICATION}?${params.toString()}`;
    let res = await get(url);
    if (res?.status === "success") {
      setList((prev) => ({ ...prev, [isActiveTab]: res?.data }));

      const updatedPagination = {
        ...pagination,
        [isActiveTab]: {
          current_page: pageNo,
          last_page: res?.total_pages,
          count: res?.count,
        },
      };

      setPagination(updatedPagination);
      setIsCount(res?.count);
      addToGlobal({
        pagination: updatedPagination,
        isActiveTab,
        selectedFilter,
        page: pageNo,
      });
    }
  };

  const submitRemark = async (skip = false) => {
    let payload = {
      remark: skip ? "" : remark,
    };
    handleCloseRemark();
    let res = await put(
      `${URLS.AI_NOTIFICATION_UPDATE}${openRemark?.id}/`,
      payload,
    );
    if (res?.status === "success") {
      toast.success(res?.message);
      getList(page);
    }
  };

  useEffect(() => {
    getList(page);
  }, [isActiveTab, page]);

  useEffect(() => {
    if (selectedFilter.from && selectedFilter.to) {
      setPage(1);
      getList(1);
    }
  }, [selectedFilter.to]);

  return (
    <div>
      <Topbar header="AI Notification" subHead="Notification List" />
      <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
        Total:{isCount}
      </h2>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: 20,
        }}
      >
        <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
          {Object.values(READ_STATUS).map((status) => (
            <div
              key={status}
              role="button"
              tabIndex={0}
              style={{
                background: isActiveTab === status ? "#AE55F5" : "#78788029",
                textAlign: "center",
                padding: "10px 20px",
                borderRadius: 8,
                cursor: "pointer",
              }}
              onClick={() => handleTabChange(status)}
            >
              <p style={{ color: isActiveTab === status ? "#fff" : "#000" }}>
                {status}
              </p>
            </div>
          ))}
        </div>
      </div>

      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination?.[isActiveTab] ?? {}}
        data={list?.[isActiveTab] ?? []}
        show={true}
      />

      <Dialog
        open={Boolean(openRemark)}
        onClose={handleCloseRemark}
        fullWidth
        maxWidth="sm"
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <DialogTitle>Add Remark</DialogTitle>
          <IconButton onClick={handleCloseRemark} size="small" sx={{ mr: 1 }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>

        <DialogContent>
          <TextField
            autoFocus
            multiline
            minRows={4}
            fullWidth
            placeholder="Enter your remark..."
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => submitRemark(true)}>Skip</Button>
          <Button
            onClick={() => submitRemark(false)}
            variant="contained"
            disabled={!remark.trim()}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AiNotification;
